import { inject, Injectable } from '@angular/core'
import { PositionOptionInterface } from '@modules/options-module/positions/interfaces/position-option.interface'
import { BehaviorSubject } from 'rxjs'
import { OptionTypeEnum } from '@modules/options-module/general/enums/option-type.enum'
import { ParsedOptionSymbolInterface } from '@modules/options-module/general/interfaces/parsed-option-symbol.interface'
import { OptionsHelperService } from '@modules/options-module/general/services/options-helper.service'

@Injectable({
	providedIn: 'root',
})
export class PositionsOptionsHelperService {
	protected readonly number: NumberConstructor = Number
	protected readonly optionTypeEnum: typeof OptionTypeEnum = OptionTypeEnum

	public positionsOptions$: BehaviorSubject<PositionOptionInterface[]> = new BehaviorSubject<
		PositionOptionInterface[]
	>([])
	public isLoadingPositionsOptions$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	private readonly _optionsHelperService: OptionsHelperService = inject<OptionsHelperService>(OptionsHelperService)

	public parsePositions(positions: PositionOptionInterface[]): PositionOptionInterface[] {
		return positions.map((position: PositionOptionInterface): PositionOptionInterface => {
			const parsedOptionSymbol: ParsedOptionSymbolInterface | null = this._optionsHelperService.parseOptionSymbol(
				position.symbol,
			)
			if (!parsedOptionSymbol) return position

			return {
				...position,
				...parsedOptionSymbol,
			}
		})
	}

	public removePosition(symbol: string): void {
		const currentPositions: PositionOptionInterface[] = this.positionsOptions$.getValue()
		const updatedPositions: PositionOptionInterface[] = currentPositions.filter(
			(position: PositionOptionInterface): boolean => position.symbol !== symbol,
		)
		this.positionsOptions$.next(updatedPositions)
	}
}
